import React from 'react';

const COLORS = {
  red: { bg: '#ffe0e0', text: '#c0392b', label: 'Critical' },
  yellow: { bg: '#fff3cd', text: '#d68910', label: 'Warning' },
  green: { bg: '#d4edda', text: '#27ae60', label: 'Info' },
  unknown: { bg: '#e9ecef', text: '#636e72', label: 'Unknown' },
};

export default function SeverityBadge({ severity, showLabel = true }) {
  const c = COLORS[severity?.toLowerCase?.()] || COLORS.unknown;
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      background: c.bg,
      color: c.text,
    }}>
      {showLabel ? c.label : severity}
    </span>
  );
}
